import type {
  CustomAiColumnTemplate,
  CustomAiColumnTemplateListResponse,
} from '@/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../base-query';

export const customAiColumnTemplatesApi = createApi({
  reducerPath: 'customAiColumnTemplatesApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['CustomAiColumnTemplate'],
  endpoints: (builder) => ({
    listCustomAiColumnTemplates: builder.query<
      CustomAiColumnTemplateListResponse,
      { isActive?: boolean; skip?: number; limit?: number }
    >({
      query: ({ isActive, skip = 0, limit = 50 }) => {
        const params = new URLSearchParams({
          skip: skip.toString(),
          limit: limit.toString(),
        });
        if (isActive !== undefined) {
          params.append('is_active', isActive.toString());
        }
        return {
          url: `/ai/column-templates?${params}`,
          method: 'GET',
        };
      },
      providesTags: ['CustomAiColumnTemplate'],
    }),

    incrementTemplateUsage: builder.mutation<CustomAiColumnTemplate, string>({
      query: (id) => ({
        url: `/ai/column-templates/${id}/increment-usage`,
        method: 'POST',
      }),
      invalidatesTags: ['CustomAiColumnTemplate'],
    }),
  }),
});

export const {
  useListCustomAiColumnTemplatesQuery,
  useIncrementTemplateUsageMutation,
} = customAiColumnTemplatesApi;
